// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heGhGKYQBAuMwPZhZUu4{min-height:unset;padding:16px 20px 12px}._YLjr8VdqkSwJFl6pd_r{margin-bottom:32px;padding-left:20px}.K463ggHs5IgtOs6jRawH{padding-left:20px;padding-right:20px;flex-direction:column;gap:12px;padding-bottom:15px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `heGhGKYQBAuMwPZhZUu4`,
	"wrapStatus": `_YLjr8VdqkSwJFl6pd_r`,
	"statistics": `K463ggHs5IgtOs6jRawH`
};
export default ___CSS_LOADER_EXPORT___;
